const dayjs = require('dayjs')

// 檢查是不是在自家的app 裡
const isPDSWAPP = () => {
  return navigator.userAgent.includes('PDSW') // PDSW 是app 定義的
}
// app 的postMessage 部分
const sendMessageToPDSW = (callbackHandler, type, data) => {
  if (navigator.userAgent.includes('iPhone')) {
    window.webkit.messageHandlers[callbackHandler].postMessage({ method: type, url: data })
  } else {
    data ? window[callbackHandler][type](data) : window[callbackHandler][type]
  }
}
// 封裝過的跳板
const appJumpTo = ({ host = process.env.MARKSIX_SERVER_HOST, path = '' } = {}) => {
  const url = `${host}${path}`
  if (isPDSWAPP()) {
    return sendMessageToPDSW('Router', 'intent', url)
  }
  window.open(url, '_blank') // 使用了applink 的東西，.well-known 資料夾下有一個assetlinks.json 檔
}

// Sean for homepage
const Countdown_HomePage = function(config) {
  // timer實體
  this.timer = null
  // server時間
  this.currentTime = new Date(config.currentTime)
  // 結束時間
  this.nextPeriodTime = new Date(config.nextPeriodTime)
  // 時間格式
  this.formatTime = null
  // 倒數間隔
  this.duration = config.duration ? config.duration : 1
  // 結束時的回呼
  this.finishedCallback = config.finishedCallback ? config.finishedCallback : Function.prototype
  // 結束時回呼的參數
  this.finishedParameter = config.finishedParameter ? config.finishedParameter : {}
  // 倒數中的回呼
  this.tickerCallback = config.tickerCallback ? config.tickerCallback : Function.prototype
  // 倒數中回呼的參數
  this.tickerParameter = config.tickerParameter ? config.tickerParameter : {}

  // 開始計時
  this.startTimer = () => {
    this.timer = window.setTimeout(() => {
      this.countdown()
      this.tickerCallback(this.tickerParameter)
      if (this.nextPeriodTime - this.currentTime <= 0) {
        this.finishedCallback(this.finishedParameter)
        this.kill()
        return
      }
      this.startTimer()
    }, this.duration * 1000)
  }

  // 秒數計算
  this.countdown = () => {
    this.currentTime = new Date(dayjs(this.currentTime).add(this.duration, 'seconds'))
    this.formatTime = this.pattern(this.currentTime, this.nextPeriodTime)
  }
  // 時間轉換
  this.pattern = (current, next) => {
    const msec = next - current

    let _day = parseInt((msec / 1000 / 60 / 60 / 24) % 30)
    let _hour = parseInt((msec / 1000 / 60 / 60) % 24)
    let _min = parseInt((msec / 1000 / 60) % 60)
    let _sec = Math.ceil((msec / 1000) % 60)

    _day = _day > 9 ? `${_day}` : `0${_day}`
    _hour = _hour > 9 ? `${_hour}` : `0${_hour}`
    _min = _min > 9 ? `${_min}` : `0${_min}`
    _sec = _sec === 60 ? '00' : _sec > 9 ? `${_sec}` : `0${_sec}`

    return {
      mon: _day,
      hour: _hour,
      min: _min,
      sec: _sec
    }
  }

  // kill timer實體
  this.kill = () => { clearTimeout(this.timer) }
}
// flyc for other pages
const Countdown = function(config) {
  config = config || {}

  // sync prototype function
  var _format = Object.getPrototypeOf(this)._format
  var _milliSecondToPattern = Object.getPrototypeOf(this)._milliSecondToPattern

  // duplicate instance
  var _timer_instance = this

  // id
  var sequence = Object.getPrototypeOf(this).sequence++
  this.id = 'Countdown-' + sequence

  // ticker 間隔
  this.duration = config.duration ? config.duration : 1000
  // 結束時間
  this.closeTime = config.closeTime ? _format(config.closeTime) : _format(new Date())

  // 是否自動清除計時器
  this.killWhenFinished = config.killWhenFinished ? config.killWhenFinished : true

  // 每次間隔要做的事情
  this.tickerCallback = config.tickerCallback ? config.tickerCallback : Function.prototype
  this.tickerParameter = config.tickerParameter ? config.tickerParameter : {}

  // 倒數結束要做的事情
  this.finishedCallback = config.finishedCallback ? config.finishedCallback : Function.prototype
  this.finishedParameter = config.finishedParameter ? config.finishedParameter : {}

  // 時間文字
  this.leftTimeText = ''
  this.leftTime = {
    year: '',
    month: '',
    days: '',
    hours: '',
    minutes: '',
    seconds: ''
  }

  // 剩餘時間
  this.deltaMilliSecond = 0

  // 計時器本體
  this.timer = null

  // 開始計時
  this.start = function() {
    if (!_interval_function()) return

    this.timer = setInterval(_interval_function, this.duration)

    function _interval_function() {
      var currentMilliSecond = (new Date()).getTime()
      var closeMilliSecond = (new Date(_timer_instance.closeTime)).getTime()

      var deltaMilliSecond = closeMilliSecond - currentMilliSecond
      var leftTimeResult = _milliSecondToPattern(deltaMilliSecond)
      var leftTimeText = leftTimeResult.text
      var leftTime = leftTimeResult.map

      _timer_instance.deltaMilliSecond = deltaMilliSecond
      _timer_instance.leftTimeText = deltaMilliSecond > 0 ? leftTimeText : '-'
      _timer_instance.leftTime = Object.assign(_timer_instance.leftTime, leftTime)

      _timer_instance.tickerCallback(_timer_instance.tickerParameter)

      if (deltaMilliSecond <= 0) {
        if (_timer_instance.killWhenFinished) {
          _timer_instance.kill()
        }

        _timer_instance.finishedCallback(_timer_instance.finishedParameter)
        return false
      }

      return true
    }
  }

  // 清除計時器
  this.kill = function() {
    clearInterval(this.timer)
  }

  Object.getPrototypeOf(this).allCountdownInstances.push(this)
}
Countdown.prototype.sequence = 0
Countdown.prototype.allCountdownInstances = []
Countdown.prototype.formatPattern = 'YYYY-MM-DD HH:mm:ss'
Countdown.prototype.killAll = function killAll() {
  this.allCountdownInstances.forEach(function(dateInstance) {
    return dateInstance.kill()
  })
}
Countdown.prototype._format = function _format(dateInput) {
  switch (true) {
    case dateInput instanceof Date:
      return dateInput.getTime()

    case /^\d+$/.test(dateInput):
      return dateInput

    case /^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}/.test(dateInput):
      return new Date(dateInput).getTime()

    default:
      console.warn('時間格式有誤: 請輸入"YYYY-MM-DD HH:mm:ss" 或 毫秒數 或 Date實體, 將使用當前時間', dateInput)
      return _format(new Date())
  }
}
Countdown.prototype._milliSecondToPattern = function _milliSecondToPattern(deltaMilliSecond) {
  var milliSecondMap = (function() {
    var milliSecond = 1
    var second = 1000 * milliSecond
    var minute = 60 * second
    var hour = 60 * minute
    var day = 24 * hour

    return {
      milliSecond: milliSecond,
      second: second,
      minute: minute,
      hour: hour,
      day: day
    }
  })()

  var modDay = Math.floor(deltaMilliSecond / milliSecondMap.day)
  var modHours = Math.floor((deltaMilliSecond % milliSecondMap.day) / milliSecondMap.hour)
  var modMinutes = Math.floor((deltaMilliSecond % milliSecondMap.hour) / milliSecondMap.minute)
  var modSeconds = Math.ceil((deltaMilliSecond % milliSecondMap.minute) / milliSecondMap.second)

  var days = __paddingZero(modDay, 2)
  var hours = __paddingZero(modHours, 2)
  var minutes = __paddingZero(modMinutes, 2)
  var seconds = __paddingZero(modSeconds, 2)

  return {
    text: days + ' ' + hours + ':' + minutes + ':' + seconds,
    map: {
      days: days,
      hours: hours,
      minutes: minutes,
      seconds: seconds
    }
  }

  function __paddingZero(inputNumber, paddingNumber) {
    inputNumber = inputNumber || 0
    paddingNumber = paddingNumber || 2
    var delta = paddingNumber - inputNumber.toString().length

    if (delta > 0) {
      var zeros = (new Array(delta)).fill().map(function() {
        return '0'
      }).join('')
      return zeros + inputNumber
    } else {
      return inputNumber.toString()
    }
  }
}

const accountFormat = function(account, frontLen = 2, endLen = 2) {
  const len = account.length - frontLen - endLen
  let str = ''
  for (let i = 0; i < len; i++) {
    str += '*'
  }
  return account.substring(0, frontLen) + str + account.substring(account.length - endLen)
}

const getThisAndLastYear = () => {
  const currentYear = dayjs().year()
  const lastYear = currentYear - 1
  return [currentYear, lastYear]
}

const imageSearchNoDataMsg = '很抱歉，您查找的期数已查无资料，请查阅最新的图纸'

const YEARS_2 = 365 * 2 + 1 // 不包含今天的前 730 天
const YEARS_3 = 365 * 3 // 不包含今天的前 3 年
const YEARS_5 = 365 * 6 // 不包含今年的前 5 年
const DAYS_90 = 90 + 1 // 不包含今日的前 90 天

// 彩票對應的資料可查詢時間範圍
const LOTTERIES_BY_DATA_DURATION = {
  'fc3d': { name: '福彩3D', categoryCode: 'china', duration: YEARS_3 },
  'pl3': { name: '排列3', categoryCode: 'china', duration: YEARS_3 },
  'fcssq': { name: '福彩双色球', categoryCode: 'china', duration: YEARS_3 },
  'qlc': { name: '七乐彩', categoryCode: 'china', duration: YEARS_3 },
  'cjdlt': { name: '超级大乐透', categoryCode: 'china', duration: YEARS_3 },
  'pl5': { name: '排列5', categoryCode: 'china', duration: YEARS_3 },
  'qxc': { name: '七星彩', categoryCode: 'china', duration: YEARS_3 },
  'fckl8': { name: '福彩快乐8', categoryCode: 'china', duration: YEARS_3 },
  'fcxy28': { name: '福彩幸运28', categoryCode: 'china', duration: YEARS_3 },
  'smam6': { name: '澳门赛马会', categoryCode: 'local', duration: DAYS_90 },
  'newam6': { name: 'New澳门六合彩', categoryCode: 'local', duration: YEARS_2 },
  'nam6': { name: '新澳门六合彩', categoryCode: 'local', duration: YEARS_2 },
  'am6': { name: '澳门六合彩', categoryCode: 'local', duration: YEARS_2 },
  'hk6': { name: '香港六合彩', categoryCode: 'local', duration: YEARS_5 },
  'jspk10': { name: '极速PK拾', categoryCode: 'jisu', duration: DAYS_90 },
  'wfpk10': { name: '五分PK拾', categoryCode: 'jisu', duration: DAYS_90 },
  'jsssc': { name: '极速时时彩', categoryCode: 'jisu', duration: DAYS_90 },
  'wfssc': { name: '五分时时彩', categoryCode: 'jisu', duration: DAYS_90 },
  'jisuk3': { name: '极速快3', categoryCode: 'jisu', duration: DAYS_90 },
  'sfk3': { name: '三分快3', categoryCode: 'jisu', duration: DAYS_90 },
  'wfk3': { name: '五分快3', categoryCode: 'jisu', duration: DAYS_90 },
  'jisu11x5': { name: '极速11选5', categoryCode: 'jisu', duration: DAYS_90 },
  'sf11x5': { name: '三分11选5', categoryCode: 'jisu', duration: DAYS_90 },
  'wf11x5': { name: '五分11选5', categoryCode: 'jisu', duration: DAYS_90 },
  'amff6': { name: '澳门分分六合彩', categoryCode: 'jisu', duration: DAYS_90 },
  'amsf6': { name: '澳门三分六合彩', categoryCode: 'jisu', duration: DAYS_90 },
  'amwf6': { name: '澳门五分六合彩', categoryCode: 'jisu', duration: DAYS_90 },
  'ff6': { name: '极速六合彩', categoryCode: 'jisu', duration: DAYS_90 },
  'sf6': { name: '三分六合彩', categoryCode: 'jisu', duration: DAYS_90 },
  'js6': { name: '五分六合彩', categoryCode: 'jisu', duration: DAYS_90 },
  'wfxy28': { name: '五分幸运28', categoryCode: 'jisu', duration: DAYS_90 },
  'wfkl8': { name: '五分快乐8', categoryCode: 'jisu', duration: DAYS_90 },
  'naozxy10': { name: '新澳洲幸运10', categoryCode: 'gaopin', duration: DAYS_90 },
  'aozxy10': { name: '澳洲幸运10', categoryCode: 'gaopin', duration: DAYS_90 },
  'malxyft': { name: '幸运飞艇', categoryCode: 'gaopin', duration: DAYS_90 },
  'naozxy5': { name: '新澳洲幸运5', categoryCode: 'gaopin', duration: DAYS_90 },
  'aozxy5': { name: '澳洲幸运5', categoryCode: 'gaopin', duration: DAYS_90 },
  'jndbskl8': { name: '加拿大卑诗快乐8', categoryCode: 'gaopin', duration: DAYS_90 },
  'twbingo': { name: '台湾宾果', categoryCode: 'gaopin', duration: DAYS_90 },
  'jndbsxy28': { name: '加拿大幸运28', categoryCode: 'gaopin', duration: DAYS_90 },
  'twxy28': { name: '台湾幸运28', categoryCode: 'gaopin', duration: DAYS_90 }
}

/**
 * 取得指定彩種的資料可查詢時間範圍
 * @param {string} lotteryCode 彩票代碼
 * @returns {Object} 彩票資料可查詢時間範圍的 Map 物件
 * @example getLotteryDataDurationMap('hk6') => { name: '香港六合彩', categoryCode: 'local', duration: YEARS_5 }
 */
const getLotteryDataDurationMap = (lotteryCode) => {
  return LOTTERIES_BY_DATA_DURATION[lotteryCode] || {}
}

const minYearDefault = 2019

/**
 * 取得是否包含今年在內往前推指定範圍的年份陣列
 * @param {Object} options - 參數物件
 * @param {number} options.range - 年份範圍，預設為 2 年
 * @param {boolean} options.includeCurrentYear - 是否包含今年，預設為 false
 * @param {number} options.currentYear - 目前的年份，預設為當前的年份
 * @returns {Array<number>} - 年份陣列
 * @example getRangeYear({ range: 3, includeCurrentYear: true, currentYear: 2025 }) => [2025, 2024, 2023]
 * @example getRangeYear({ range: 3, includeCurrentYear: false, currentYear: 2025 }) => [2024, 2023, 2022]
 */
const getRangeYear = ({ range = 2, includeCurrentYear = false, currentYear = dayjs().year() } = {}) => {
  const years = []
  const offset = includeCurrentYear ? 0 : 1 // 是否包含今年
  for (let i = 0; i < range; i++) {
    years.push(currentYear - i - offset)
  }
  return years
}

/**
 * 取得香港六合彩往前推 range 年的年份陣列
 * @example hk6YearRange() => [2025, 2024, 2023, 2022, 2021, 2020]
 * @returns {Array<number>} - 年份陣列
 */
const hk6YearRange = () => {
  return getRangeYear({ range: 6, includeCurrentYear: true }) // 包含今年在內共 6 年
}

// 更新開獎日曆 calendar 的顯示狀態
const updateView = (vm, currentDate) => {
  updateArrowStates(vm, currentDate)
  updateDayStates(vm)
}
// 更新 minDate 與 maxDate 範圍內的箭頭狀態
const updateArrowStates = (vm, currentViewDate) => {
  const calendarEl = vm.calendarEl?.$el
  if (!calendarEl) {
    console.error('Calendar component element not found.')
    return
  }

  const prevArrow = calendarEl.querySelector('.wh_top_changge .wh_jiantou1')?.parentElement
  const nextArrow = calendarEl.querySelector('.wh_top_changge .wh_jiantou2')?.parentElement
  if (!prevArrow || !nextArrow) {
    console.error('Calendar arrow elements not found in the DOM.')
    return
  }

  const minMonth = dayjs(vm.minDate)
  const maxMonth = dayjs(vm.maxDate)

  prevArrow.classList.toggle('disabled', currentViewDate.isSame(minMonth, 'month') || currentViewDate.isBefore(minMonth, 'month'))
  nextArrow.classList.toggle('disabled', currentViewDate.isSame(maxMonth, 'month') || currentViewDate.isAfter(maxMonth, 'month'))
}
// 更新非 minDate 與 maxDate 範圍內的日期狀態
const updateDayStates = (vm) => {
  const calendarEl = vm.calendarEl?.$el
  const calendarList = vm.calendarEl?.list
  if (!calendarEl || !calendarList) return

  const dayCells = calendarEl.querySelectorAll('.wh_content:last-child .wh_content_item')
  const minDate = dayjs(vm.minDate)
  const maxDate = dayjs(vm.maxDate)

  dayCells.forEach((cell, index) => {
    const dayInfo = calendarList[index]
    if (!dayInfo || !dayInfo.date) return

    const cellDate = dayjs(dayInfo.date)
    const isDisabled = cellDate.isBefore(minDate, 'day') || cellDate.isAfter(maxDate, 'day')
    cell.classList.toggle('disabled', isDisabled)
  })
}

export {
  isPDSWAPP,
  sendMessageToPDSW,
  appJumpTo,
  Countdown_HomePage,
  Countdown,
  accountFormat,
  getThisAndLastYear,
  getRangeYear,
  minYearDefault,
  getLotteryDataDurationMap,
  LOTTERIES_BY_DATA_DURATION,
  hk6YearRange,
  updateView,
  imageSearchNoDataMsg
}
